/**
 * Lightweight subsequence fuzzy matcher: returns a score (lower = better)
 * when every char of `needle` appears in order within `haystack`. Used so
 * typing "crd vs" matches "Cardiovascular system" or "intro" matches
 * "Introduction to Anatomy" without requiring contiguous substrings.
 * Returns null when there is no match.
 */
export function fuzzyScore(haystack: string, needle: string): number | null {
  if (!needle) return 0;
  const h = haystack.toLowerCase();
  const n = needle.toLowerCase();
  if (h.includes(n)) return n.length; // substring wins
  let hi = 0,
    ni = 0,
    gaps = 0,
    lastHit = -1;
  while (hi < h.length && ni < n.length) {
    if (h[hi] === n[ni]) {
      if (lastHit >= 0) gaps += hi - lastHit - 1;
      lastHit = hi;
      ni++;
    }
    hi++;
  }
  return ni === n.length ? n.length + gaps : null;
}
